import { Country } from '../../lib/types/models/country/country'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCountry(id: number) {
  return restApiClient.url(constructApiUrl(API.countries.get.url, { id })).get<Country>()
}
